import api from "@/api/productLayout/productLayout";

const getLayouts = () =>
  new Promise((resolve, reject) => {
    api
      .getLayouts()
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const createLayout = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .createLayout(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const updateLayout = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .updateLayout(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const deleteLayout = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .deleteLayout(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getPartnerSectors = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getPartnerSectors(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const uploadImageToLayout = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .uploadImageToLayout(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getImageForLayout = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getImageForLayout(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const createRelationSectorToLayout = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .createRelationSectorToLayout(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const deleteRelationSectorToLayout = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .deleteRelationSectorToLayout(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getLayoutData = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getLayoutData(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const uploadImageToSeat = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .uploadImageToSeat(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getImageForSeat = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getImageForSeat(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const createSeatLayout = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .createSeatLayout(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

// const getSeatLayout = (context, payload) =>
//   new Promise((resolve, reject) => {
//     api
//       .getSeatLayout(payload)
//       .then((response) => {
//         console.log(response);
//         resolve(response);
//       })
//       .catch((error) => {
//         console.error(error);
//         reject(error);
//       });
//   });

const getSeatsForLayout = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getSeatsForLayout(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const createRelationSeatToLayout = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .createRelationSeatToLayout(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const deleteRelationSeatToLayout = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .deleteRelationSeatToLayout(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const updateSeatLayout = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .updateSeatLayout(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getPartnersForLayouts = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getPartnersForLayouts(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

export default {
  getLayouts,
  createLayout,
  updateLayout,
  deleteLayout,
  getPartnerSectors,
  uploadImageToLayout,
  getImageForLayout,
  createRelationSectorToLayout,
  deleteRelationSectorToLayout,
  getLayoutData,
  uploadImageToSeat,
  getImageForSeat,
  createSeatLayout,
  // getSeatLayout,
  getSeatsForLayout,
  createRelationSeatToLayout,
  deleteRelationSeatToLayout,
  updateSeatLayout,
  getPartnersForLayouts,
};
